import { type Dispatch, type SetStateAction, useCallback, useState } from "react"

export type UseCheckboxReturnType = [{
    onClick: () => void,
    checked: boolean
}, Dispatch<SetStateAction<boolean>>]

/**
 * Хук, который используется в паре с компонентом [Checkbox](/docs/shared-ui-kit-checkbox)
 * @param initChecked начальное состояние чекбокса
 */
export function useCheckbox(initChecked: boolean) {
    const [checked, setChecked] = useState(initChecked);

    const onClick = useCallback(() => {
        setChecked(cur => !cur)
    }, []);

    return [{onClick, checked}, setChecked] as UseCheckboxReturnType;
}